import { Link } from "react-router-dom";
import { FaMagnifyingGlass, FaCartShopping, FaCheckDouble } from 'react-icons/fa6'
import { Card } from "react-bootstrap";
import { Col, Row } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";


export default function MenuPedidos() {
    return <>
        <Breadcrumb>
            <Breadcrumb.Item><Link to="/">Inicio</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>Pedidos</Breadcrumb.Item>
        </Breadcrumb>
        <nav>
            <Row>
                <Col sm="4" className="mb-2">
                    <Link to="/pedidos/consulta">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaMagnifyingGlass></FaMagnifyingGlass>
                                </Card.Title>
                                <Card.Text>Consulta</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col sm="4" className="mb-2">
                    <Link to="/pedidos/nuevo">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaCartShopping></FaCartShopping>
                                </Card.Title>
                                <Card.Text>Nuevo</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col sm="4" className="mb-2">
                    <Link to="/pedidos/entrega">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaCheckDouble></FaCheckDouble>
                                </Card.Title>
                                <Card.Text>Entrega</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
        </nav>
    </>
}